export const SKIP_TO_ISSUE = '__$session-skipToIssue$__';
export const TIMEZONE = '__$session-timezone$__';
export const TIMEZONE_LOCAL = '__$session-timezone$_local__';
export const SHOWN_TIMEZONE = '__$session-shownTimezone$__';
export const DURATION_FILTER = '__$session-durationFilter$__';
export const SESSION_FILTER = '__$session-filter$__';
export const GLOBAL_DESTINATION_PATH = '__$global-destinationPath$__';
export const GLOBAL_HAS_NO_RECORDINGS = '__$global-hasNoRecordings$__';
export const SITE_ID_STORAGE_KEY = '__$user-siteId$__';
export const GETTING_STARTED = '__$user-gettingStarted$__';
export const MOUSE_TRAIL = '__$session-mouseTrail$__';
export const VIRTUAL_MODE_KEY = '__$session-virtualMode$__';
export const IFRAME = '__$session-iframe$__';
export const JWT_PARAM = '__$session-jwt-param$__';
export const MENU_COLLAPSED = '__$global-menuCollapsed$__';
export const SPOT_ONBOARDING = '__$spot-onboarding$__';
